import React from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Card, Button, Alert, Container } from 'react-bootstrap';
import Header from '../components/Layout/Header';

const PaymentFailedPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { error, orderId } = location.state || {};

  const handleRetry = () => {
    history.goBack();
  };

  return (
    <>
      <Header />
      <Container className="d-flex align-items-center justify-content-center min-vh-100">
        <Card className="text-center shadow" style={{ maxWidth: '600px', width: '100%' }}>
          <Card.Body className="p-5">
            <div className="mb-4">
              <div className="text-danger mb-3" style={{ fontSize: '80px' }}>
                ✗
              </div>
              <h2 className="mb-3 text-danger">Échec du paiement</h2>
              <p className="text-muted mb-4">
                Désolé, votre paiement n'a pas pu être traité. Veuillez réessayer.
              </p>

              {error && (
                <Alert variant="danger" className="text-start">
                  <Alert.Heading className="h6">Détails de l'erreur</Alert.Heading>
                  <p className="mb-0 small">{error}</p>
                </Alert>
              )}

              {orderId && (
                <div className="bg-light p-3 rounded mb-4">
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Numéro de commande:</span>
                    <strong>#{orderId}</strong>
                  </div>
                  <p className="small text-muted mb-0 mt-2">
                    Votre commande est en attente. Veuillez réessayer le paiement.
                  </p>
                </div>
              )}

              <div className="alert alert-warning">
                <strong>Problèmes courants</strong>
                <ul className="text-start mb-0 mt-2 small">
                  <li>Vérifiez que les informations de votre carte sont correctes</li>
                  <li>Assurez-vous que votre carte dispose de fonds suffisants</li>
                  <li>Vérifiez la limite de votre carte bancaire</li>
                  <li>Contactez votre banque si le problème persiste</li>
                </ul>
              </div>
            </div>

            <div className="d-grid gap-2">
              <Button variant="danger" size="lg" onClick={handleRetry}>
                Réessayer le paiement
              </Button>
              <Link to="/commande">
                <Button variant="outline-secondary" size="lg" className="w-100">
                  Modifier la commande
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="link" className="w-100">
                  Contacter le support
                </Button>
              </Link>
              <Link to="/">
                <Button variant="link" className="w-100">
                  Retour à l'accueil
                </Button>
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default PaymentFailedPage;
